import dayjs from "dayjs";

export const materialColumns = (navigate, options = {}) => {
  const { showView = false, showManage = true } = options;

  return [
  {
    title: "Product Name",
    dataIndex: "productName",
    key: "productName",
    render: (key) => {
      return <div>{key || "-"}</div>;
    },
  },
  {
    title: "Product Code",
    dataIndex: "productCode",
    key: "productCode",
    render: (key) => {
      return <div>{key || "-"}</div>;
    },
  },
  {
    title: "Images",
    dataIndex: "images",
    key: "images",
    render: (key) => {
      return <div>{key ?? "-"}</div>;
    },
  },
  {
    title: "Videos",
    dataIndex: "videos",
    key: "videos",
    render: (key) => {
      return <div>{key ?? "-"}</div>;
    },
  },
  {
    title: "PDFs",
    dataIndex: "pdfs",
    key: "pdfs",
    render: (key) => {
      return <div>{key ?? "-"}</div>;
    },
  },
  {
    title: "FAQs",
    dataIndex: "faqs",
    key: "faqs",
    render: (key) => {
      return <div>{key ?? "-"}</div>;
    },
  },
  {
    title: "Date Created",
    dataIndex: "dateCreated",
    key: "dateCreated",
    render: (key) => {
      return <div>{key ? dayjs(key).format("MM/DD/YYYY") : "-"}</div>;
    },
  },
  {
    title: "Action",
    key: "action",
    render: (row) => {
      if (!showView && !showManage) {
        return null;
      }

      const navigateToMaterial = () => {
        navigate("/ai-campaigns/manage-material", { state: row });
      };

      return (
        <div className="action-icons">
          <div className="grid2 d-flex">
            {showManage && (
              <button
                className="manage"
                style={{
                  fontFamily: "Gotham",
                  fontWeight: "400 ",
                }}
                type="button"
                onClick={navigateToMaterial}
              >
                Manage
              </button>
            )}
            {showView && (
              <button
                className="manage"
                style={{
                  fontFamily: "Gotham",
                  fontWeight: "400 ",
                }}
                type="button"
                onClick={navigateToMaterial}
              >
                View
              </button>
            )}
          </div>
        </div>
      );
    },
  },
];
};
